import React from 'react';
import {
  Typography,
  Stack
} from '@mui/material';
import {
  LocationOn,
  Edit,
  Add
} from '@mui/icons-material';
import { Operation } from '../../../../networkRequest/operationsService';
import LocationAddress from './LocationAddress';

interface OperationLocationsProps {
  operation: Operation;
  onEditPrimaryLocation?: () => void;
  onAddLocation?: () => void;
  onRemoveLocation?: (locationId: string) => void;
}

const OperationLocations: React.FC<OperationLocationsProps> = ({ operation, onEditPrimaryLocation, onAddLocation, onRemoveLocation }) => {
  // Get primary and additional locations from operation data
  const primaryLocation = operation.operation_locations.find(loc => loc.primary);
  const additionalLocations = operation.operation_locations.filter(loc => !loc.primary);

  const handleEditPrimaryLocation = () => {
    if (onEditPrimaryLocation) {
      onEditPrimaryLocation();
    } else {
      console.log('Edit primary location');
    }
  };

  const handleAddLocation = () => {
    if (onAddLocation) {
      onAddLocation();
    } else {
      console.log('Add new location');
    }
  };

  const handleRemoveLocation = (locationId: string | undefined) => {
    if (onRemoveLocation && locationId) {
      onRemoveLocation(locationId);
    } else {
      console.log('Remove location:', locationId);
    }
  };

  return (
    <Stack spacing={0}>
      {/* Section Header with icon and count */}
      <Stack direction="row" spacing={2} sx={{
        alignItems: "center"
      }}>
        <LocationOn />
        <Typography variant="h5">
          Locations
        </Typography>
        <Typography
          variant="body1"
          sx={{
            backgroundColor: 'blueGrey.50',
            px: 1,
            py: 0.5,
            borderRadius: 1
          }}
        >
          {operation.operation_locations.length}
        </Typography>
      </Stack>

      <Stack spacing={2} sx={{ mt: 4 }}>
        {/* Primary Location */}
        <LocationAddress
          location={primaryLocation}
          primary={true}
          sectionTitle="Primary Location"
          actionButtonText="Edit"
          actionButtonIcon={<Edit />}
          onAction={handleEditPrimaryLocation}
        />

        {/* Additional Locations */}
        <LocationAddress
          locations={additionalLocations}
          primary={false}
          sectionTitle="Additional Locations"
          actionButtonText="Location"
          actionButtonIcon={<Add />}
          onAction={handleAddLocation}
          onRemove={handleRemoveLocation}
        />
      </Stack>
    </Stack>
  );
};

export default OperationLocations;